var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUpIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlSpace: "preserve",
    width: "100%",
    height: "100%",
    viewBox: "0 0 304 297",
    preserveAspectRatio: "xMidYMid",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Untitled") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\r\n  Generated by SVGmaker V3 Version 3.61.E702.64\r\n  JUL-24-2026, 10:55\r\n")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "page_clip"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 304,
    height: 297
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page_1",
    clipPath: "url(#page_clip)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    stroke: "none",
    d: "M 151,29 l 109,109 0,42 -94,-95 0,190 -30,0 0,-190 -94,95 0,-42 109,-109 z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpIcon);
export default __webpack_public_path__ + "static/media/Arrow_Up_Icon.5969499ae2f45ba886e3ed25c44357b1.svg";
export { ForwardRef as ReactComponent };